import {
    Button as AntdButton,
    Col as AntdCol,
    Row as AntdRow,
    Form,
    Input,
    Select,
    Table,
    notification, Popconfirm, Tooltip, DatePicker, Image,
} from "antd";
import {Option} from "antd/es/mentions";
import {ColumnsType} from "antd/es/table";
import React, {useEffect, useState} from "react";
import {Card, Col, Row} from "react-bootstrap";
import CustomPagination from "../../components/CustomPagination";
import PageTitle from "../../components/PageTitle";
import { useNavigate } from 'react-router-dom';
import VideoPlayer from "../../components/VideoPlayer";
import { searchEpisodeCaptureVideo } from "../../helpers/api/episodeCaptureVideo";

const { RangePicker } = DatePicker;

interface EpisodeCaptureVideoModel {
    key: React.Key;
    id: string;
    userId: string;
    episodeId: string;
    videoUrl: string;
    imageUrl: string;
    level: number;
    storyName: string;
    createdAt: Date;
    modifiedAt: Date;

}

const EpisodeCaptureVideo = () => {
    const navigate = useNavigate(); // Lấy đối tượng navigate

    const [pageSize, setPageSize] = useState<number>(10);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [totalRecord, setTotalRecord] = useState<number>(0);
    const [episodeCaptureVideos, setEpisodeCaptureVideos] = useState<EpisodeCaptureVideoModel[]>([]);

    const [api, contextHolder] = notification.useNotification();

    const [form] = Form.useForm();
    const formValueObj = Form.useWatch([], form);
    const [searchLoading, setSearchLoading] = useState<boolean>(false);



    const columns: ColumnsType<EpisodeCaptureVideoModel> = [
        {
            title: "No.",
            dataIndex: "noNumber"
        },
        {
            title: "Image",
            dataIndex: "name",
            render: (text, record, index) => {
                return (
                    <span>
                            <Image
                                width={60}
                                src={record.imageUrl}
                            />
                    </span>
                )
            },
        },
        {
            title: "Video",
            dataIndex: "videoUrl",
            render: (text, record, index) => {
                return (
                    <span>
                        <VideoPlayer 
                            url={record.videoUrl} 
                            width={80} 
                            height={60}
                            thumbnail={record.imageUrl}
                        />
                    </span>
                )
            },
        },
        {
            title: "User ID",
            dataIndex: "userId",
            render: (text, record, index) => {
                return <span>{record?.userId}</span>
            }
        },
        {
            title: "Story Name",
            dataIndex: "storyName",
            render: (text, record, index) => {
                return <span>{record?.storyName}</span>
            }
        },
        {
            title: "Level",
            dataIndex: "level",
            render: (text, record, index) => {
                return <span>{record?.level}</span>
            }
        },
        {
            title: "Created at",
            dataIndex: "createdAt",
            render: (text, record, index) => {
                return <span>{record?.createdAt ? new Date(record?.createdAt).toLocaleString() : ''}</span>
            }
        },
    ];

    useEffect(() => {
        search();
    }, [pageIndex]);

    useEffect(() => {
        if (pageIndex === 1) {
            search();
            return;
        }
        setPageIndex(1);
    }, [pageSize]);

    const search = async () => {
        setSearchLoading(true);
        const searchObj: any = {
            pageIndex: pageIndex - 1,
            pageSize,
        };
        if (formValueObj?.searchingDate) {
            searchObj["fromDate"] = new Date(formValueObj?.searchingDate[0]).toISOString();
            searchObj["toDate"] = new Date(formValueObj?.searchingDate[1]).toISOString();
        }
        if (formValueObj?.storyName) {
            searchObj["storyName"] = formValueObj?.storyName;
        }
        if (formValueObj?.episodeLevel) {
            searchObj["episodeLevel"] = formValueObj?.episodeLevel;
        }
        try {
            const response = await searchEpisodeCaptureVideo(searchObj);
            if (response.status === 200) {
                const data: any[] = [];
                response.data.data.forEach((item: any, index: number) => {
                    data.push({
                        ...item,
                        noNumber: (pageIndex - 1) * pageSize + index + 1,
                    });
                });
                setEpisodeCaptureVideos(data);
                setTotalRecord(response.data.totalRecord);
            }
        } catch (err) {
            console.error(err);
            api.error({
                message: `Error notification`,
                description: <span className="text-danger">{err as string || 'There\'re some errors occured!'}</span>,
                placement: 'topRight'
            });
        }
        setSearchLoading(false);
    }



    return (
        <>
            {contextHolder}
            <PageTitle
                breadCrumbItems={[
                    {label: "Episode Capture Video", path: "/episode_capture_videos"},
                ]}
                title={"Episode Capture Video"}
            />

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Form layout="vertical" autoComplete='off' form={form}>
                                <AntdRow gutter={16}>
                                    <AntdCol span={12}>
                                        <Form.Item
                                            name="searchingDate"
                                            label="Date"
                                        >
                                            <RangePicker className="w-100" showTime />
                                        </Form.Item>
                                    </AntdCol>
                                    
                                </AntdRow>
                                <AntdRow gutter={16}>
                                    <AntdCol span={12}>
                                        <Form.Item
                                            name="storyName"
                                            label="Story"
                                        >
                                            <Input placeholder="Please enter name"/>
                                        </Form.Item>
                                    </AntdCol>
                                    <AntdCol span={12}>
                                        <Form.Item
                                            name="episodeLevel"
                                            label="Level"
                                        >
                                            <Select
                                                placeholder="Select"
                                                allowClear
                                            >
                                                <Option value="1">1</Option>
                                                <Option value="2">2</Option>
                                                <Option value="3">3</Option>
                                                <Option value="4">4</Option>
                                            </Select>

                                        </Form.Item>
                                    </AntdCol>
                                </AntdRow>
                                <AntdRow className="justify-content-center">
                                    <AntdCol>
                                        <AntdButton type="primary" className="me-1" htmlType="submit"
                                                    loading={searchLoading}
                                                    onClick={() => {
                                                        if (pageIndex === 1) {
                                                            search();
                                                            return;
                                                        }
                                                        setPageIndex(1);
                                                    }}
                                        >
                                            Search
                                        </AntdButton>
                                        <AntdButton type="default" loading={searchLoading} onClick={() => {
                                            form.resetFields();
                                            if (pageIndex === 1) {
                                                search();
                                                return;
                                            }
                                            setPageIndex(1);
                                        }}>
                                            Reset
                                        </AntdButton>
                                    </AntdCol>
                                </AntdRow>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Table
                                loading={searchLoading}
                                rowKey={"noNumber"}
                                className="table table-hover m-0 table-centered dt-responsive nowrap w-100"
                                dataSource={episodeCaptureVideos}
                                columns={columns}
                                pagination={false}
                            />

                            {episodeCaptureVideos?.length !== 0 && (
                                <CustomPagination
                                    pageIndex={pageIndex}
                                    pageSize={pageSize}
                                    totalItem={totalRecord}
                                    setPageSize={setPageSize}
                                    setPageIndex={setPageIndex}
                                />
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default EpisodeCaptureVideo;
